import { getStateWithOnlyOneLevel } from '../../../utils/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'personalizedStudy');
}

export const getAvailableChaptersSelector = (state) =>
  getState(state).get('availableChapters');

export const getAvailableChaptersLoadingSelector = (state) =>
  getState(state).get('availableChaptersLoading');

export const getSaveChaptersLoadingSelector = (state) =>
  getState(state).get('saveChaptersLoading');

export const getChapterStudyPlanSelector = (state) =>
  getState(state).get('chapterStudyPlan');

export const getBuildChapterStudyPlanLoadingSelector = (state) =>
  getState(state).get('buildChapterStudyPlanLoading');
